import authApi from 'api/authApi';
import { updateAxiosAccessToken } from 'api/axiosClient';
import AppConstants from 'general/constants/AppConstants';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import ToastHelper from 'general/helpers/ToastHelper';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// dang nhap
export const thunkLogIn = createAsyncThunk('auth/thunkLogIn', async (params, thunkAPI) => {
  try {
    const res = await authApi.signIn(params);
    return res;
  } catch (error) {
    return {
      result: 'failed',
      reason: error?.response?.data?.reason ?? 'Đăng nhập không thành công',
    };
  }
});

// ---- params ----
const initialState = {
  isLoggingIn: false,
  user: {},
  agencyRoleList: [],
  permissionList: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuthSlice: (state, action) => {
      return initialState;
    },
    updateUser: (state, action) => {
      state.user = action.payload ?? {};
    },
    setAgencyRoleList: (state, action) => {
      state.agencyRoleList = action.payload ?? '';
    },
    setPermissionList: (state, action) => {
      state.permissionList = action.payload ?? '';
    },
  },
  extraReducers: {
    // dang nhap
    [thunkLogIn.pending]: (state, action) => {
      state.isLoggingIn = true;
    },
    [thunkLogIn.rejected]: (state, action) => {
      state.isLoggingIn = false;
    },
    [thunkLogIn.fulfilled]: (state, action) => {
      state.isLoggingIn = false;
      const { result, user, reason } = action.payload;
      if (result == 'success') {
        let token = user?.token;
        localStorage.setItem(PreferenceKeys.accessToken, token);
        localStorage.setItem(PreferenceKeys.savedLoginEmail, user?.email);
        updateAxiosAccessToken(token);
        state.user = user ?? {};
        if (user?.role === AppConstants.userRole.agency && !_.isUndefined(user.agency)) {
          const agencyRoleList = [
            ...new Set(
              user?.agency?.commissions?.map((commission) => ({
                role: commission.role,
                commissionId: commission.commissionId
              })) || []
            )
          ];

          agencyRoleList.sort((a, b) => a.commissionId - b.commissionId);

          state.agencyRoleList = [...new Set(agencyRoleList.map(item => item.role))];
        }

        const permissionList = user?.permissionGroup?.permissions?.map((permission) => {
          return { path: permission.fe_path, code: permission.code };
        })
        state.permissionList = permissionList;
      } else {
        ToastHelper.showError(reason);
      }
    },
  },
});

const { reducer, actions } = authSlice;
export const { resetAuthSlice, updateUser, setAgencyRoleList, setPermissionList } = actions;
export default reducer;
